import styled from 'styled-components'

import { Color } from '../../config/styles/colors'
import { ProgressRingProps } from '../../config/types'

const ContainerSVG = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 0.5em;
  justify-content: center;
  align-items: center;
`

const Circle = styled.circle`
  transition: stroke-dashoffset 0.35s;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
`

const Text = styled.span`
  color: #fff;
  font-size: 1.5em;
  font-weight: bold;
`

const ProgressRing = ({ radius, stroke, progress }: ProgressRingProps) => {
  const normalizedRadius = radius - stroke * 2
  const circumference = normalizedRadius * 2 * Math.PI

  const strokeDashoffset = circumference - (progress / 100) * circumference

  return (
    <ContainerSVG>
      <svg height={radius * 2} width={radius * 2}>
        <Circle
          stroke="#ffffff"
          fill="transparent"
          strokeWidth={stroke}
          stroke-width={stroke}
          r={normalizedRadius + 5}
          cx={radius}
          cy={radius}
        />
        <Circle
          stroke={Color.GREEN}
          fill="transparent"
          strokeWidth={stroke}
          strokeDasharray={circumference + ' ' + circumference}
          style={{ strokeDashoffset }}
          stroke-width={stroke}
          r={normalizedRadius - 1}
          cx={radius}
          cy={radius}
        />
      </svg>

      <Text>LOADING...</Text>
    </ContainerSVG>
  )
}

export default ProgressRing
